import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import GrillaPage from "./pages/GrillaPage";
import GrillaMensualPage from "./pages/GrillaMensualPage";
import ProduccionPage from "./pages/ProduccionPage";
import SmallScreenWarning from "./components/SmallScreenWarning";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <SmallScreenWarning />
                <Routes>
                    <Route path="/" element={<Navigate replace to="/grilla" />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/grilla" element={<ProtectedRoute><GrillaPage /></ProtectedRoute>} />
                    <Route path="/mensual" element={<ProtectedRoute><GrillaMensualPage /></ProtectedRoute>} />
                    <Route path="/produccion" element={<ProtectedRoute><ProduccionPage /></ProtectedRoute>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </AuthProvider>
    );
}

// Simple protected route
function ProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();

    if (loading) return null; // Wait for auth to initialize

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    return children;
}

export default App;
